import { redirect } from "@tanstack/react-router";

/**
 * /dashboard → Avatar ready-room page.
 * Kept as a redirect so old "Ready room" links keep working.
 */
export function DashboardPage() {
  // Component should not render — route beforeLoad redirects.
  return null;
}

/** Call from router beforeLoad. */
export function redirectDashboardToAvatar() {
  throw redirect({ to: "/dashboard/avatar" });
}
